
import { Button } from "@/components/ui/button";
import { useTimedAccess } from "@/context/TimedAccessContext";
import { useAuth } from "@/context/AuthContext";
import { Timer } from "lucide-react";
import { useLocation } from "react-router-dom";
import { trackButtonClick } from "@/utils/tracking";
import { ENABLE_FREE_ACCESS } from "@/utils/freeAccessConfig";

interface FreeAccessButtonProps {
  className?: string;
}

const FreeAccessButton = ({ className }: FreeAccessButtonProps) => {
  const { hasFreeAccess, startFreeAccess } = useTimedAccess();
  const { isSubscribed } = useAuth();
  const location = useLocation();

  if (!ENABLE_FREE_ACCESS) {
    return null;
  }
  
  // Don't show button if user is already subscribed or has active free access
  if (isSubscribed || hasFreeAccess) {
    return null;
  }
  
  // Check if free access was previously used
  const hasUsedFreeAccess = localStorage.getItem("helloml_free_access_used") === "true";
  
  if (hasUsedFreeAccess) {
    return null;
  }
  
  // Handle the click event
const handleStartFreeAccess = () => {
  // Track the button click for analytics
  trackButtonClick("get_free_access_button");

  // Pass the current location as the redirect URL
  startFreeAccess(location.pathname);
};
  
  return (
    <Button 
      variant="secondary" 
      size="lg" 
      className={className}
      onClick={handleStartFreeAccess}
    >
      <Timer className="mr-2 h-4 w-4" />
      Get Free Access
    </Button>
  );
};

export default FreeAccessButton;
